import React, { Fragment } from 'react';
import {
    Avatar,
    Box,
    IconButton,
    SvgIcon,
    Theme,
    Typography,
    makeStyles,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { IModalHeader } from './types';
import { X } from 'react-feather';
import getInitials from 'src/utils/getInitials';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { CapitalizeNames as capitalize } from 'src/utils/capitalize';
import { AWS_S3 } from 'src/constants/crm/aws';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundImage: `linear-gradient(${theme.palette.primary.main} 72%, ${theme.palette.background.paper} 0%)`,
        paddingRight: theme.spacing(7),
        paddingLeft: theme.spacing(2),
        paddingTop: theme.spacing(3),
        gap: theme.spacing(3),
        position: 'relative',
        display: 'flex',
        color: '#FFF',
    },
    avatar: {
        width: 120,
        height: 120,
    },
    closeIcon: {
        color: '#FFF',
        position: 'absolute',
        right: 0,
        top: 10,
    },
    date: {
        display: 'flex',
        gap: theme.spacing(2),
        alignSelf: 'flex-end',
        marginLeft: 'auto',
        position: 'absolute',
        bottom: 0,
        right: 15,
    },
    agent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.2),
    },
    agentName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: 380,
    },
}));

export const ModalHeader = ({
    lead,
    setOpen,
    isComplete,
    ...props
}: IModalHeader) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const handleClose = () => setOpen(false);

    const { agent, evaluation } = lead;

    const currentUser = evaluation?.user ? evaluation.user : agent;

    return (
        <Fragment>
            {!isComplete && (
                <Alert severity="error">{t('evaluation.notComplete')}</Alert>
            )}

            <Box className={classes.root} {...props}>
                <IconButton className={classes.closeIcon} onClick={handleClose}>
                    <SvgIcon>
                        <X />
                    </SvgIcon>
                </IconButton>
                <Avatar
                    src={`${AWS_S3}${currentUser?.image}`}
                    className={classes.avatar}
                    variant="rounded"
                >
                    {getInitials(currentUser?.name)}
                </Avatar>
                <Box className={classes.agent}>
                    <Typography
                        variant="h3"
                        color="inherit"
                        className={classes.agentName}
                    >
                        {capitalize(currentUser?.name)}
                    </Typography>
                    <Typography variant="h6" color="inherit">
                        {currentUser?.email}
                    </Typography>
                </Box>

                <Box className={classes.date}>
                    <Typography variant="body1" color="textPrimary">
                        <b>{t('evaluation.date')}:</b>{' '}
                        {moment(lead?.createdAt).format('DD MMMM YYYY')}
                    </Typography>
                    <Typography variant="body1" color="textPrimary">
                        <b>{t('evaluation.hour')}:</b>{' '}
                        {moment(lead?.createdAt).format('hh:mm a')}
                    </Typography>
                </Box>
            </Box>
        </Fragment>
    );
};
